import React from 'react'
import { CircularProgress } from '@material-ui/core'
import LogoCard from './logo-card'
import ColorsCard from './colors-card'
import CustomCodeCard from './custom-code-card'
import useBranding from './useBranding'
import useStyles from './styles'

/**
 * Workspace › Branding: logo, favicon, primary color and font (auto-saved,
 * "Saved" toast) and the workspace custom code (its own Save).
 */
const BrandingTab = () => {
  const classes = useStyles()
  const { branding, loading, save, saveCustomCode } = useBranding()

  if (loading) {
    return (
      <div className={classes.root} style={{ alignItems: 'center' }}>
        <CircularProgress size={28} />
      </div>
    )
  }

  return (
    <div className={classes.root}>
      <LogoCard branding={branding} onSave={save} />
      <ColorsCard branding={branding} onSave={save} />
      <CustomCodeCard branding={branding} onSave={saveCustomCode} />
    </div>
  )
}

export default BrandingTab
